/**
 * AccountsList Messages
 *
 * This contains all the text for the AccountsList component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.accounts';

export default defineMessages({
  listColumnHeaderTextName: {
    id: `${scope}.list.columns.headers.names.Name`,
    defaultMessage: 'Name',
  },
  listColumnHeaderTextEmail: {
    id: `${scope}.list.columns.headers.names.Email`,
    defaultMessage: 'Email',
  },
  listColumnHeaderTextRole: {
    id: `${scope}.list.columns.headers.names.Role`,
    defaultMessage: 'Role',
  },
});
